.stepper {
  display: flex;
  padding: 24px;
  font-family: var(--tuna-typography-fontFamily);
}

.horizontal {
  flex-direction: row;
  align-items: center;
}

.vertical {
  flex-direction: column;
}

.step {
  display: flex;
  flex-direction: column;
}

.horizontal .step {
  flex-direction: row;
  align-items: center;
}

.stepDisabled {
  opacity: 0.5;
  pointer-events: none;
}

.stepButton {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: var(--tuna-shape-borderRadius);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body2-fontSize, 0.875rem);
  color: var(--tuna-palette-text-primary);
  transition: background-color 150ms;
}

.stepButton:hover {
  background-color: var(--tuna-palette-action-hover);
}

.stepButton:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.stepLabel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.stepIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stepLabelText {
  display: flex;
  flex-direction: column;
}

.stepContent {
  padding: 0 0 8px 20px;
  margin-left: 12px;
  border-left: 1px solid var(--tuna-palette-divider);
}

.connector {
  flex: 1 1 auto;
}

.horizontal .connector {
  height: 1px;
  min-width: 24px;
  background-color: var(--tuna-palette-divider);
  margin: 0 8px;
}

.vertical .connector {
  width: 1px;
  min-height: 24px;
  background-color: var(--tuna-palette-divider);
  margin: 0 0 0 12px;
}
